import 'owl.carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';

export default function pressArticles() {
  $('.press-articles__wrap').owlCarousel({
    margin: 20,
    stagePadding: 0,
    dots: false,
    items: 4,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      768: {
        items: 3
      }
    }
  });
}
